import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link, useRouteMatch } from 'react-router-dom';

import { Button } from 'ui-components/components/button';
import buttonStyles from 'ui-components/components/button/button-text.module.less';

import { HOME_PAGE_PATH } from '../../../../../../routes/constants';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';

import { messages } from '../../messages';
import style from '../../onboard-cards.module.less';

export const HomePageButton = () => {
  const isOnHomePage = useRouteMatch(HOME_PAGE_PATH);
  const { closePopupGuide } = useHomePageOnboardContext();
  if (isOnHomePage) {
    return (
      <Button
        className={classnames(style['link-button'], style['footer-row-group'], buttonStyles['button-text'])}
        onClick={closePopupGuide}
        theme='link'
      >
        <FormattedMessage {...messages.onboardingCompleteStayOnHome} />
      </Button>
    );
  }
  return (
    <Link
      className={classnames(style['primary-footer-button'], style['footer-row-group'], buttonStyles['button-text'], style['link-button'])}
      onClick={closePopupGuide}
      to={HOME_PAGE_PATH}
    >
      <FormattedMessage {...messages.onboardingCompleteGoToHome} />
    </Link>
  );
};
